import { useContext, useMemo } from 'react';
import { AccountContext, useLoggedInAccount } from '@/features/account-context';
import { Role } from '@/utils/definitions';
import { getQueryParam } from '@/utils/browser';

const HIDDEN_SQL_REGEX =
  /`{3,}\s*(?:[a-zA-Z0-9_-]+\b\s*)?--\s*hid+en\b[\s\S]*?`{3,}/gi;

export const removeHiddenSqlSnippets = (content: string): string => {
  if (!content) return ``;
  const filtered = content.replace(HIDDEN_SQL_REGEX, ``);
  if (filtered === content) {
    return content;
  }
  return filtered
    .replace(/[^\S\r\n]{2,}/g, ` `)
    .replace(/\n{3,}/g, `\n\n`)
    .trim();
};

export const useCanShowHiddenPrompt = (): boolean => {
  const { account } = useContext(AccountContext);
  const loggedInAccount = useLoggedInAccount();
  const role = account?.store?.role || loggedInAccount?.store?.role;
  const isSystemUser = useMemo(() => role === Role.SYSTEM, [role]);
  return useMemo(
    () => isSystemUser && getQueryParam(`showHiddenPrompt`) === `1`,
    [isSystemUser],
  );
};

export const getVisiblePrompt = (
  content: string | undefined | null,
  canShowHiddenPrompt: boolean,
): string => {
  if (!content) return ``;
  if (canShowHiddenPrompt) {
    return content;
  }
  return removeHiddenSqlSnippets(content);
};

export const isNamedExperience = (name?: string | null): boolean =>
  !!name && name.trim().toLowerCase() !== `unnamed copilot experience`;

export const getExperienceSourcePrompt = (experience: {
  sourceAiPrompts?: string[];
}): string =>
  experience.sourceAiPrompts?.find((prompt) => !!prompt?.trim()) ||
  experience.sourceAiPrompts?.[0] ||
  ``;
